/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * IS_NULL operator looks for values that are null.
 */
export interface IsNullResourceId {}
